import FooterSlice from './FooterSlice';

export default FooterSlice.actions;
